// THE BACKEND ENDPOINT THE REACT APP WILL QUERY
export const baseURL = 'https://sandateamdk.onrender.com';
// export const baseURL = 'http://192.168.0.245:3005';